import {
  chmodSync,
  existsSync,
  mkdirSync,
  readFileSync,
  statSync,
  unlinkSync,
  writeFileSync,
} from "node:fs";
import { dirname } from "node:path";

export function fileExists(path: string): boolean {
  return existsSync(path);
}

export function readTextIfExists(path: string): string | null {
  if (!existsSync(path)) return null;

  try {
    if (!statSync(path).isFile()) {
      return null;
    }

    return readFileSync(path, "utf8");
  } catch (error) {
    const code = typeof error === "object" && error && "code" in error
      ? String(error.code)
      : undefined;

    if (code === "ENOENT" || code === "ENOTDIR" || code === "EISDIR") {
      return null;
    }

    throw error;
  }
}

export function writeTextFile(
  path: string,
  content: string,
  options: { mode?: number } = {},
): void {
  mkdirSync(dirname(path), { recursive: true });
  writeFileSync(path, content, {
    encoding: "utf8",
    ...(options.mode === undefined ? {} : { mode: options.mode }),
  });

  if (options.mode !== undefined) {
    chmodSync(path, options.mode);
  }
}

export function writeJsonFile(
  path: string,
  value: unknown,
  options: { mode?: number } = {},
): void {
  writeTextFile(path, `${JSON.stringify(value, null, 2)}\n`, options);
}

export function deleteFileIfExists(path: string): boolean {
  if (!existsSync(path)) return false;

  try {
    if (!statSync(path).isFile()) {
      return false;
    }

    unlinkSync(path);
    return true;
  } catch (error) {
    const code = typeof error === "object" && error && "code" in error
      ? String(error.code)
      : undefined;

    if (code === "ENOENT" || code === "ENOTDIR" || code === "EISDIR") {
      return false;
    }

    throw error;
  }
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value && typeof value === "object" && !Array.isArray(value));
}

export function parseJsonObject(input: string | null): Record<string, unknown> {
  if (!input) return {};

  try {
    const parsed = JSON.parse(input);
    return isRecord(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function readObject(
  value: unknown,
  fallback: Record<string, unknown> = {},
): Record<string, unknown> {
  return isRecord(value) ? value : fallback;
}
